import { render, staticRenderFns } from "./ImageTabReadOnly.vue?vue&type=template&id=0e664025&"
import script from "./ImageTabReadOnly.vue?vue&type=script&lang=js&"
export * from "./ImageTabReadOnly.vue?vue&type=script&lang=js&"
import style0 from "./ImageTabReadOnly.vue?vue&type=style&index=0&id=0e664025&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports